
import Stop from "../../../assets/duotone/Stop.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StopIcon({ className, dataTestid = "StopIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Stop data-testid={dataTestid} className={classes} {...rest} />
  );
}
